enum Theme {
  Light = "Light",
  Dark = "Dark",
  Auto = "Auto",
}
export default Theme;
